import LeftSection from './components/left-section';
import RightSection from './components/right-section';
import ArrowLeftIcon from 'components/icons/ArrowLeftIcon';

import {
  Button,
  ButtonWrapper,
  ButtonNavLink
} from 'components/common/button/button';

import { useModal } from 'components/modal-views/context';
import { DELEGATE_PAGE } from 'site-settings/site-navigation';
import { StyledHeader, StyledWrapper } from './single-page.style';

const SinglePage = ({ name }) => {
  const { openModal } = useModal();

  const onProvideClickHandler = async () => {
    openModal('DELEGATE_VIEW');
  };

  const onRevokeClickHandler = async () => {
    openModal('REVOKE_VIEW');
  };

  return (
    <>
      <StyledHeader>
        <ButtonNavLink to={DELEGATE_PAGE}>
          <ArrowLeftIcon />
        </ButtonNavLink>
        <ButtonWrapper>
          <Button
            onClick={onProvideClickHandler}
            variant="default"
            size="middle"
            fullwidth
          >
            Provide OPN
          </Button>
          <Button
            onClick={onRevokeClickHandler}
            variant="outlined"
            size="middle"
            fullwidth
          >
            Revoke OPN
          </Button>
        </ButtonWrapper>
      </StyledHeader>

      <StyledWrapper>
        <LeftSection name={name} />
        <RightSection />
      </StyledWrapper>
    </>
  );
};

export default SinglePage;
